import { useEffect } from 'react'
import { useParams } from 'react-router'
import PageMeta from '../../../components/common/PageMeta'
import { useProduct } from '../../../context/ProductContext'
import ProductResume from './ProductResume'
import { ProductTabs } from './Tabs/ProductTabs'

const ProductDetail = () => {
    const { id } = useParams<{ id: string }>()
    const { getProduct } = useProduct()

    useEffect(() => {
        if (id) getProduct(id)
    }, [getProduct, id])

    return (
        <>
            <PageMeta title='Produto | CRM' description='Dados do produto' />
            <div className='space-y-4'>
                <ProductResume />
                <ProductTabs />
            </div>
        </>
    )
}

export default ProductDetail
